<!-- Dialog For Tenant -->
  <h2 matDialogTitle>Change Tenant</h2>
  <mat-dialog-content>

  <div class="tenant-section tenant-info-gap">
    <div class="tenant-row">
      <span class="tenant-label me-2">Current Tenant:</span>
      <span class="tenant-value">{{(user && user.tenant) ? user.tenant.name : '' }}</span>
    </div>

    <div class="tenant-row">
      <span class="tenant-label me-2">Current Database:</span>
      <span class="tenant-value">{{(user && user.tenant) ? user.tenant.initialCatalog : '' }}</span>
    </div>
  </div>
    
  <div>
    <mat-form-field class="d-block">
      <mat-label>Tenant Name</mat-label>
      <mat-select [(ngModel)]="selectedTenant">
        <mat-option *ngFor="let tenant of tenantList;" [value]="tenant.tenantId">
          {{ tenant.name }}
        </mat-option>
      </mat-select>
      <mat-spinner *ngIf="tenantGet" [diameter]="20"></mat-spinner>
    </mat-form-field>
  </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="changeTenant()">Ok</button>
    <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
    <button mat-button (click)="onCancelClick()">Cancel</button>
  </mat-dialog-actions>